import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
/**
 *
 * @param {*} apiRoutes  : Parametro para hacer una petición a una API especifica
 * @returns : Retorna un array de objetos de la consulta que se hizo
 */

async function updateDatos(apiRoutes = "", data = {}) {
  const MySwal = withReactContent(Swal);
  try {
    const instance = axios.create({
      baseURL: `${process.env.REACT_APP_URLBASE}apigeomedellin`,
      method: "PUT",
    });

    const { data: responseAxios } = await instance.put(apiRoutes, data);
    if (responseAxios.ok) {
      return responseAxios;
    } else {
      alert(responseAxios.message);
    }
  } catch (err) {
    console.log("updateDatos err", err);
    MySwal.fire({
      title: "Advertencia",
      text: err.response.data.message,
      confirmButtonText: "Aceptar",
      customClass: {
        title: "sweet-alert-title-error",
        htmlContainer: "sweet-alert-container-error",
        confirmButton: "sweet-alert-confirm-button-error",
      },
    });
    throw err;
  }
}

export default updateDatos;
